import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material';

const useStyles = makeStyles((theme: Theme) => ({
  slimNavBar: {
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '4px 0',
    boxSizing: 'border-box',
    width: '42px',
    flexShrink: 0,
  },
  slimNavTabs: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '4px',
    overflowY: 'auto',
    overflowX: 'hidden',
    flex: 1,
    minHeight: 0,
    padding: '4px 0',
    '&::-webkit-scrollbar': {
      width: '3px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'rgba(255, 255, 255, 0.4)',
      borderRadius: '3px',
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
  },
  slimNavItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '6px',
    borderRadius: '4px',
    cursor: 'pointer',
    position: 'relative',
    flexShrink: 0,
  },
  slimNavIcon: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    zIndex: 1,
    '& svg': {
      width: '20px',
      height: '20px',
      color: 'inherit',
      fill: 'currentColor',
      '& path': {
        fill: 'currentColor',
      },
    },
  },
  slimNavItemActive: {
    '&::after': {
      position: 'absolute',
      borderRadius: '4px',
      content: '""',
      background: '#fff',
      display: 'block',
      height: '100%',
      width: '100%',
      zIndex: 0,
      left: 0,
      top: 0,
    },
    '& span': {
      position: 'relative',
      zIndex: 1,
      color: '#000',
    },
    '& $slimNavIcon svg path': {
      fill: '#000',
    },
  },
  slimNavActions: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '4px',
    flexShrink: 0,
    marginTop: '8px',
    '& .MuiSwitch-root': {
      transform: 'scale(0.75)',
    },
  },
  slimNavActionButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    padding: '4px',
    borderRadius: '4px',
    transition: 'background-color 0.2s ease',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.15)',
    },
    '& svg': {
      width: '18px',
      height: '18px',
      color: 'white',
      '& path': {
        fill: 'white',
      },
    },
  },
}));

export default useStyles;
